import { useLocation } from 'react-router-dom'

export const getSearchParams = <T = Record<string, string>>(
  search: string,
): T => {
  const urlSearchParams = new URLSearchParams(search)
  const queryParams = {} as T
  urlSearchParams.forEach((value, key) => {
    queryParams[key] = value
  })

  return queryParams
}
export const useQuery = <T = Record<string, string>>(): T => {
  return getSearchParams<T>(useLocation().search)
}
